<template>
    <div style="position:relative;width:100%;height:100%;">
        <nav class="agx-navbar-shop agx-theme-bg navbar navbar-fixed-top" style="z-index:100;">

            <div class="agx-navbar-wrapper" style="position:relative;" :style="{'margin-left':contentMarginLeft +'px'}">
                <slot name="topNavRight"></slot>
                <div>
                    <div class="navbar-header">

                        <button type="button" :style="{display:navIn?'none':'block'}" style="float: left;" class="navbar-toggle" @click="toggleNav">
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                            <span class="icon-bar"></span>
                        </button>

                        <slot name="topNavBrand"></slot>

                    </div>
                    <div class="agx-nav-bar navbar-collapse collapse">
                            <slot name="topNavMenus"></slot>
                    </div>
                </div>

            </div>
        </nav>

        <nav @click="toggleNav" class="navbar sidebar agx-theme-bg" role="navigation"
             :style="{'margin-left':sideMenuMarginLeft +'px','width': menuWidth +'px' }" style="border-right: 1px solid gray; border-radius: 0px; position: fixed;height: 100%; float: left; z-index: 8000; margin-bottom: 0px; ">
            <div class="container-fluid" style="padding: 0 0px 0 0px;height:100%;overflow-y:auto;overflow-x:hidden;">
                <button type="button" style="float: left; display: block; height: 34px;" class="navbar-toggle">
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                    <span class="icon-bar"></span>
                </button>
               
                <!-- Collect the nav links, forms, and other content for toggling -->
                <div style="clear: both;">
                    <slot name="sideMenu"></slot>
                </div>

            </div>
        </nav>

        <div class="main" style="position: relative;height: 100%;"
            :style="{ 'margin-left': contentMarginLeft + 'px', 'padding-top': navBarBottom === true ? '0px' : '50px', 'padding-bottom': navBarBottom === true ? '50px' : '0px' }">
            <modal-relative :show="navIn" @clicked="toggleNav"></modal-relative>
            <div style="height: 100%;">

                <div style=" position: relative;height: 100%; float: left;"
                    :style="{ 'width': (showLeftCol ? '30%' : '0%') }">
                    <slot name="leftBody" v-if="showLeftCol"></slot>
                </div>
                <div class="scrolling-container" ref="rightBody"
                    style=" position: relative;height: 100%; float: right;"
                    :style="{ 'width': (showLeftCol ? '70%' : '100%') }">
                    <div>
                        <slot name="topBody"></slot>
                    </div>
                    <slot name="body"></slot>
                </div>
            </div>
        </div>

        <div
            style="position: fixed; bottom: 6px; left: 10px; text-align: center; z-index: 100; background: rgb(128, 128, 128,0.8);height:44px;padding:2px;">
            <div style="color:white;">
                <span class="btn glyphicon glyphicon-arrow-left" @click="$router.go(-1)"></span>
                <template>
                    <slot name="bottomNavCenter"></slot>
                </template>
                <span class="btn glyphicon glyphicon-arrow-right" @click="$router.go(+1)"></span>
            </div>
        </div>  

    </div>
</template>

<script>
    import { pages } from '../../../vue.config';
import Loading from '../base/Loading.vue';
    import ModalRelative from '../base/ModalRelative.vue';

    export default {
        components: {
            Loading: Loading,
            ModalRelative: ModalRelative
        },
        props: {

        },
        computed: {
            navBarBottom: function () {
                return this.$store.getters.navBarBottom;
            },
            sideMenuMarginLeft: function () {
                return this.navIn === true ? 0 : -this.menuWidth;
            },
            contentMarginLeft: function () {
                return this.navIn === true ? this.menuWidth : 0;
            },
            isLargerThanSM: function () {
                return this.windowWidth > 768;
            },
            showLeftCol: function () {
                return false;
            },
            isCenteredContent: function () {
                var pagesList = ["index","listing","articles"];
                return pagesList.indexOf(this.currentPageName) < 0;
            }
        },
        data: function () {
            return {
                menuWidth:250,
                navIn: false,
                windowWidth: window.innerWidth,
                isIndexPage: false,
                currentPageName: this.$router.currentRoute.name
            }
        },
        methods: {
            toggleNav: function () {
                this.navIn = !this.navIn;
            },
            toggleMenu: function () {
                this.showMenu = !this.showMenu;
            },
            windowWidthUpdate: function () {
                this.windowWidth = window.innerWidth;
            },
            indexPageCheck: function () {
                this.currentPageName = this.$router.currentRoute.name;
                this.isIndexPage = this.currentPageName === 'index';
            }
        },
        created: function () {
            window.addEventListener('resize', this.windowWidthUpdate);
            this.indexPageCheck();
        },
        destroyed: function () {
            window.removeEventListener("resize", this.windowWidthUpdate);
        },
        watch: {
            '$route'() {
                this.indexPageCheck();
            }
        }
    }
</script>
